import React from "react";
import CusButton from "../../../mui/custom_button/CusButton";
import { ENUM_LOGIN } from "../../../../store/enums";
import { setModalLogin, setTypeLogin } from "../../../../store/siteSlice";
import { useDispatch } from "react-redux";
import "./login-buttons.scss";

export default function LoginButtons() {
  const dispatch = useDispatch();

  const onLoginClick = () => {
    dispatch(setTypeLogin(ENUM_LOGIN.login));
    dispatch(setModalLogin(true));
  };
  const onRegClick = () => {
    dispatch(setTypeLogin(ENUM_LOGIN.register));
    dispatch(setModalLogin(true));
  };

  return (
    <div className="no-auth-buttons">
      <CusButton text="Register" color="custom" defCusColor="gradient-blue" onClick={onRegClick} />
      <CusButton text="Login" color="primary" onClick={onLoginClick} />
    </div>
  );
}
